import { render, staticRenderFns } from "./ContributionCalendar.vue?vue&type=template&id=2dfd60cd&scoped=true"
import script from "./ContributionCalendar.vue?vue&type=script&lang=js"
export * from "./ContributionCalendar.vue?vue&type=script&lang=js"
import style0 from "./ContributionCalendar.vue?vue&type=style&index=0&id=2dfd60cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd60cd",
  null
  
)

export default component.exports